import React, { useMemo } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';
import { useTemplateStudioState } from 'state/hooks/template-studio.hook';

import AcSelect from 'components/AcSelect/AcSelect';
import { AcSelectProps } from 'components/AcSelect/AcSelect.types';
import { cn } from 'components/lib/utils';
import { EThemes } from 'components/TemplatesStudio/enums';
import { FormControl, FormItem, FormMessage } from 'components/ui';

const ChevronDownIcon = (props: { className?: string }) => (
  <FontAwesomeIcon
    icon="fa-solid fa-chevron-down text-xs mr-[9px] mt-[-2px]"
    className={cn('text-base-foreground text-[#404040]', props.className)}
  />
);

export const ThemesFormItem: React.FC<{
  onChange: AcSelectProps['setSelectedItems'];
  value: AcSelectProps['value'];
}> = ({ onChange, value }) => {
  const { supportedThemes } = useTemplateStudioState();

  const themesOptions = useMemo(
    () =>
      supportedThemes!.map((value: EThemes) => ({
        value,
        content: value
          .replace(/-/g, ' ')
          .replace(/\b\w/g, (char: string) => char.toUpperCase()),
        key: value
      })),
    [supportedThemes]
  );

  const handleRenderThemesValue = (selected: any) => {
    const selectedLength = selected?.length;
    const selectedValue = themesOptions.find(
      (option: any) => option.value === selected[0]
    )?.content;
    if (
      selected &&
      selectedLength < themesOptions?.length &&
      selectedLength > 1
    )
      return selected
        .map(
          (item: string) =>
            themesOptions.find((option: any) => option.value === item)?.content
        )
        .join(', ');
    if (selectedLength === 1) return selectedValue;
    return 'All';
  };

  return (
    <FormItem>
      <FormControl>
        <div className="flex items-center justify-between mt-2">
          <span className="text-xs text-black whitespace-nowrap">Themes</span>
          <div className="w-[120px] text-xs">
            <AcSelect
              items={themesOptions}
              isCheckBox
              placeholder="All"
              isPlaceholderBold
              setSelectedItems={onChange}
              value={value || []}
              renderValue={handleRenderThemesValue}
              isApplyBtnEnabled={false}
              selectFieldClassName={'h-[30px]'}
              IconComponent={ChevronDownIcon}
            />
          </div>
        </div>
      </FormControl>
      <FormMessage />
    </FormItem>
  );
};
